module.exports = __webpack_public_path__ + "static/media/add-webhook-page.8a345036.png";